module.exports = __webpack_public_path__ + "static/media/policies.27748485.svg";